import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Landing from "./views/Landing.vue";
import Pub from "./views/Pub.vue";
import Res_blog from "./views/ei_course.vue";
import About from "./views/About.vue";

import Components from "./views/Components.vue";
import Profile from "./views/Profile.vue";
import Ei_course from "./views/ei_course.vue";
import Sys_Ml from "./views/Sys_Ml.vue";
import Teaching from "./views/Teaching.vue";
import Sys_ml_seminar from "./views/Sys_ml_seminar.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/pub",
      name: "pub",
      components: {
        header: AppHeader,
        default: Pub,
        footer: AppFooter
      }
    },
    {
      path: "/res_blog",
      name: "res_blog",
      components: {
        header: AppHeader,
        default: Res_blog,
        footer: AppFooter
      }
    },
    {
      path: "/about",
      name: "about",
      components: {
        header: AppHeader,
        default: About,
        footer: AppFooter
      }
    },
    {
      path: "/works",
      name: "works",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/products",
      name: "products",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/components",
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      }
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    },
    {
      path: "/ML_Sys",
      name: "ML_Sys",
      components: {
        header: AppHeader,
        default: Sys_Ml,
        footer: AppFooter
      }
    },
    {
      path: "/ML_Sys_seminar",
      name: "ML_Sys_seminar",
      components: {
        header: AppHeader,
        default: Sys_ml_seminar,
        footer: AppFooter
      }
    },
    {
      path: "/ei",
      name: "ei",
      components: {
        header: AppHeader,
        default: Ei_course,
        footer: AppFooter
      }
    },
    {
      path: "/Teaching",
      name: "Teaching",
      components: {
        header: AppHeader,
        default: Teaching,
        footer: AppFooter
      }
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
